import Icon from "../../shared/Icon";
import { TemplateItemInfo } from "./templates";

function TemplateItem({
  data,
  onSelect,
  selected = false,
}: {
  data: TemplateItemInfo;
  onSelect: (data: TemplateItemInfo) => void;
  selected: boolean;
}) {
  let rotate = data.label === "Horizontal" ? "rotate-90" : "";
  let iconColor = "text-black";
  switch (data.icon) {
    case "Facebook":
      iconColor = "text-[#3b5998]";
      break;
    case "Twitter":
      iconColor = "text-[#1da1f2]";
      break;
    case "Instagram":
      iconColor = "text-[#f56040]";
      break;
    case "Youtube":
      iconColor = "text-[#ff0000]";
      break;
    case "Linkedin":
      iconColor = "text-[#0a66c2]";
      break;
    case "Pinterest":
      iconColor = "text-[#e60023]";
      break;
    default:
      iconColor = "text-black";
      break;
  }

  return (
    <div
      className={`flex h-32 cursor-pointer flex-col items-center justify-center rounded-lg border-2 px-2 text-center transition-all duration-200 hover:shadow-md ${
        selected
          ? "border-blue-500 bg-blue-50 shadow-sm"
          : "border-gray-200 bg-white hover:border-gray-300"
      }`}
      onClick={() => {
        onSelect(data);
      }}
    >
      <div className={`mb-2 ${rotate} ${iconColor}`}>
        <Icon size={24} iconName={data.icon} />
      </div>
      <div className="text-xs font-medium leading-tight text-gray-900">
        {data.label}
      </div>
      <div className="mt-1 text-[11px] text-gray-500">
        {data.width} x {data.height}
      </div>
    </div>
  );
}

export default TemplateItem;
